import React, { Component } from 'react';
import { Button, Col, Form, Modal } from 'react-bootstrap';

import './CategoryChange.css';

class CategoryChange extends Component {

    constructor(props) {
        super(props);

        this.state = {
            assets: [],
            assetTitle: 'Asset',
            errMsg: ''
        };
    }

    onLoad = () => {
        //console.log("Modal is loaded");

        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all assets
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({ assets: data });
        })
        .catch(console.log)

        fetch('get_asset_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ assetTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    //colours are stored as 6 hex digits without '#' (see the category list swatch rendering);
    //the native picker works in '#rrggbb', so convert in both directions
    handlePickColour = (e) => {
        this.props.handleUpdateColourChange({ target: { value: e.target.value.replace('#', '') } });
    }

    pickerColour = () => {
        const colour = this.props.category.colour;
        return /^[0-9a-fA-F]{6}$/.test(colour) ? '#' + colour : '#000000';
    }

    handleUpdateCategory = (e) => {
        //console.log("handleUpdateCategory");

        e.preventDefault();
        e.stopPropagation();

        fetch('category_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "categoryId=" + this.props.category.categoryId + "&title=" + this.props.category.title + "&colour=" + this.props.category.colour + "&assetId=" + this.props.category.assetId
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].update)
            {
                this.setState({
                    errMsg: ''
                });

                this.props.hideUpdateCategory();
            }
            else
            {
                this.setState({
                    errMsg: data[0].msg
                });
            }
        })
    }

    renderAssetData = () => {

        return this.state.assets.map((asset) => (
            <option value={asset.assetId}>{asset.asset}</option>
        ))
    }

    render() {
        return (

            <Modal
              show={this.props.updateCategoryVisible}
              onHide={this.props.hideUpdateCategory}
              onEntered={this.onLoad}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Update {this.props.categoryTitle || 'Category'}</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                <Form className="ProcessAddForm" onSubmit={this.handleSubmit}>
                    <Form.Row>
                        <Form.Group as={Col} controlId="frmTitle">
                            <Form.Label class="CategoryAddLabel">Title</Form.Label>
                            <Form.Control className="CategoryAddControl" type="text" placeholder="title" value={this.props.category.title} onChange={this.props.handleUpdateTitleChange}/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="frmColour">
                            <Form.Label class="CategoryAddLabel">Colour</Form.Label>
                            <div style={{ display: 'flex' }}>
                                <Form.Control className="CategoryAddControl" type="text" placeholder="colour" value={this.props.category.colour} onChange={this.props.handleUpdateColourChange}/>
                                <input
                                    type="color"
                                    title="Pick a colour"
                                    value={this.pickerColour()}
                                    onChange={this.handlePickColour}
                                    style={{ width: '3rem', marginLeft: '0.5rem', padding: '0', border: '1px solid #282c34', borderRadius: '0.25rem', cursor: 'pointer', alignSelf: 'stretch' }}
                                />
                            </div>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Label class="CategoryAddLabel">{this.state.assetTitle}</Form.Label>
                        <Form.Control as="select" size="sm" value={this.props.category.assetId} onChange={this.props.handleUpdateAssetIdChange}>
                            { this.renderAssetData() }
                        </Form.Control>
                    </Form.Row>

                </Form>
            </div>
            </Modal.Body>

            <Modal.Footer>
                <span className="userAddErr">{this.state.errMsg}</span>
                <Button onClick={this.handleUpdateCategory}>Update</Button>
                <Button onClick={this.props.hideUpdateCategory}>Close</Button>
            </Modal.Footer>
            </Modal>
        )
    }
}

export default CategoryChange;
